import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { Button, Select } from '@engecomp/shared/components';
import { useOrganizationsContext, useUserContext } from '@engecomp/shared/contexts';
import { RPaths } from '@engecomp/shared/utils';

import LogoIcon from '@engecomp/shared/icons/logo.svg';

import styles from './index.module.css';

export function ChooseCompanyPage() {
  const [selected, setSelected] = useState<string>();

  const { user, selectedMembership, userType, memberships, onChangeOrganization } = useUserContext();
  const { getOrganizations } = useOrganizationsContext();

  useEffect(() => {
    getOrganizations();
  }, []);

  useEffect(() => {
    if (selectedMembership) setSelected(selectedMembership.organization?._id);
  }, [selectedMembership]);

  const handleEnter = () => {
    if (!selected) {
      toast.error('Selecione uma empresa para continuar.');
      return;
    }

    onChangeOrganization(selected);

    const routeGroup = RPaths[userType as keyof typeof RPaths];

    if ('root' in routeGroup) {
      window.location.href = routeGroup.root;
    } else {
      toast.error('Esse tipo de usuário não possui rota de redirecionamento.');
      console.warn(`RPaths[${userType}] não possui a propriedade 'root'`);
    }
  };

  return (
    <div className={styles.ChooseCompanyPage}>
      <div className={styles.LogoContainer}>
        <img src={LogoIcon} alt='logo' />

        <p>
          Bem Vindo!
          <br />
          {user?.firstName} {user?.lastName}.
        </p>
      </div>

      <div className={styles.SelectContainer}>
        <Select
          style={{ zIndex: 1000 }}
          value={{
            label: selectedMembership?.organization.name,
            value: selectedMembership?.organization._id,
          }}
          options={memberships.map(({ organization }) => ({
            label: organization?.name,
            value: organization?._id,
          }))}
          onSelect={(value) => {
            try {
              onChangeOrganization(value);
            } catch (e: unknown) {
              toast.error('Tente novamente.');
              console.error(e);
            }
          }}
        />

        <Button className={styles.EnterButton} onClick={handleEnter}>
          Entrar
        </Button>
      </div>
    </div>
  );
}
